import Logo from "../../asset/Logo.jpg";
import { Stack, Box, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthRequest } from "../../util/request/authRequest";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import WaiverList from "./waiver/waiverList";
// import BookingCalendar from "./booking/bookingCalendar";
import WeeklyCalendar from "../../Components/WeeklyCalendar";
import BookingCalendar from "./booking/bookingCalendar";
import BookingMain from "./booking/bookingMain";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
const MainBoard = () => {
  const [value, setValue] = useState(0);
  const [reFresh, setReFresh] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    async function verif() {
      const response = await AuthRequest({ subLink: "auth/verifyToken" });
      //   console.log(response.status);
      //   setAuthResult(response.status);
      //   try {
      //     const response = await AuthRequest({ subLink: "auth/verifyToken" });
      //   } catch (error) {
      //     console.log(error);
      //   }
      if (response.status !== 200) {
        return navigate("/login");
      }
      if (response.status == 200) {
        return navigate("/adminDashboard");
      }
    }
    //   setAuthResult(response.data.status);

    verif();
  }, [reFresh]);

  return (
    <Stack
      direction="column"
      spacing={2}
      sx={{
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        sx={{
          //   paddingTop: "20px",
          justifyContent: "space-between",
          alignItems: "end",
          height: "10%",
          width: "90%",
          //   maxHeight: "150px",
          //   backgroundColor: "lightblue",
        }}
      >
        <Box>
          <BottomNavigation
            showLabels
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
          >
            <BottomNavigationAction
              label="Waivers"
              icon={<DriveFileRenameOutlineIcon sx={{ fontSize: "30px" }} />}
            />
            <BottomNavigationAction
              label="Booking"
              icon={<EditCalendarIcon sx={{ fontSize: "30px" }} />}
            />
            {/* <BottomNavigationAction label="Nearby" icon={<LocationOnIcon />} /> */}
          </BottomNavigation>
        </Box>
        <img src={Logo} alt={"logo"} style={{ maxHeight: "100px" }} />
      </Stack>
      <Stack>
        {value === 0 && (
          <WaiverList
            refreshData={() => {
              window.location.reload();
            }}
          />
        )}
      </Stack>
      <Stack>
        {value === 1 && (
          <>
            <BookingMain />
            {/* <BookingModal /> */}
          </>
        )}
      </Stack>

      {/* <Stack>{value === 1 && <>kasda</>}</Stack> */}
    </Stack>
  );
};

export default MainBoard;
